'use client';

import { useRegion } from '~/region/hooks';
import { cmToFeetInches } from '~/utils';

export const Height = ({ height }: { height: number }) => {
  const { isUs } = useRegion();

  const getHeight = () => {
    if (isUs) {
      const { feet, inches } = cmToFeetInches(height);

      return `${feet}' ${inches}"`;
    }

    return `${height.toFixed(2)} cm`;
  };

  return <div>{getHeight()}</div>;
};
